import { makeStyles, shorthands } from '@fluentui/react-components';

export const useAdsStudioLibraryPageContentStyle = makeStyles({
  container: {
    '& .ads-studio-grid-container': {
      marginTop: '12px',
      position: 'relative',
      ...shorthands.overflow('hidden'),
      // to show the shadow
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    '& .library-page-header': {
      position: 'sticky',
      paddingBottom: '12px',
      paddingTop: '24px',
      paddingLeft: '36px',
      paddingRight: '36px',
      marginLeft: '-21px',
      marginRight: '-21px',
      top: 0,
      zIndex: 10,
      backgroundColor: 'white',
      height: 'auto',
      '& .library-page-header-top-wrapper': {
        visibility: 'visible',
      },
      '&.show-bulk-toolbar': {
        paddingTop: '12px',
        height: '80px',
        '& .library-page-header-top-wrapper': {
          visibility: 'hidden',
        },
      },
    },
    '& .library-page-header-toolbar': {
      position: 'absolute',
      top: '12px',
      left: '36px',
      right: '36px',
      zIndex: 11,
      backgroundColor: 'white',
    },
  },
});

